<ng-template [ngIf]="!disabled">
  <digital-platform-responsive-shell [class]="debugCls1">
    <div
      responsive="column"
      [ngClass]="debugCls1"
      *ngFor="let i of debugElements"
    ></div>
  </digital-platform-responsive-shell>

  <digital-platform-responsive-shell [class]="debugCls2">
    <section
      *ngFor="let section of sections"
      [responsive]="section"
      [ngClass]="debugCls2"
    >
      <span>{{ section }}</span>
      <code>
        # Examples:<br />
        &lt;div responsive="{{ section }}"&gt;&lt;/div&gg;<br />
        &lt;div class="section-{{ section }}"&gt;&lt;/div&gg;
      </code>
    </section>
  </digital-platform-responsive-shell>
</ng-template>
